'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormNames = function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;
  return function () {
    var getFormState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return keys(getFormState(state));
    };
  };
};

exports.default = createGetFormNames;


// WEBPACK FOOTER //
// ./~/redux-form/lib/selectors/getFormNames.js